jQuery($ => {
    class MiniCart {
        constructor(element) {
            this._                = element;
            this._element         = $(element);
            this._clearCartButton = this._element.find('.m-mini-cart__clear-cart');

            this.init();
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Initialize
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        init() {
            this.setupHandlers();
            this._element.trigger( 'init', this );
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Setup Handlers
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        setupHandlers() {
            $('.m-mini-cart__clear-cart').on('click', (e) => {
                e.preventDefault();
  
                $.ajax({
                    type: 'POST', 
                    url: AJAX.url,
                    data: {
                        action: 'clear_cart', 
                    }, 
                    beforeSend: () => {
                        $('.o-header__cart-ajax-wrapper').addClass('ajax-loading');
                    }, 
                    success: (result) => {
                        if (result.data.mini_cart_trigger){
                            $('.o-header__cart-ajax-wrapper').html(result.data.mini_cart_trigger);

                            $('.o-header__cart-ajax-wrapper').removeClass('ajax-loading');

                            $('.m-drawer-trigger').drawer_trigger();

                            $('.m-drawer').drawer();
                            $('.m-drawer').drawer('handleOpen');

                            $('.m-cart-card').cart_card();

                            $('.m-product-thumbnail-card').product_thumbnail_card();
                        }
                    },
                    error: () => { 
                        $('.o-header__cart-ajax-wrapper').removeClass('ajax-loading');
                        alert('Failed to remove products from cart.');
                    }
                });
            });
        } 
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $.fn.mini_cart = function() {
        var _ = this,
                opt = arguments[0],
                args = Array.prototype.slice.call(arguments, 1),
                l = _.length,
                i,
                ret;
        for (i = 0; i < l; i++) {
            if (typeof opt == 'object' || typeof opt == 'undefined')
                _[i].mini_cart = new MiniCart(_[i], opt);
            else
                ret = _[i].mini_cart[opt].apply(_[i].mini_cart, args);
            if (typeof ret != 'undefined') return ret;
        }
        return _;
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $('.m-mini-cart').mini_cart();
});